export default __webpack_public_path__ + "static/media/contact.b7e4efc8.svg";